// Angular
import { Component, OnInit, Input } from '@angular/core';
// Models
// import { Post } from './../../models/post';
// External
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import * as lodash from 'lodash';
import { Offer } from './../../models/offer'
import { DatePipe } from '@angular/common';
import { ApiService } from './../../services/api';
import { OrderPipe } from 'ngx-order-pipe';
import { OAuthService } from "./../../services/o-auth";
import { Subject } from "rxjs/Subject";

@Component({
  templateUrl: './zest-mapping.component.html'
})
export class ZestMappingComponent implements OnInit {

  public countries: Array<any>
  public courses: Array<any>
  public order = 'startDate';
  public imageLoader = false;
  public reverse = true;
  public filterargs: any;
  public isBankAttached = false
  public club: any;
  public clubCourses: Array<any>
  public parentSubject: Subject<any> = new Subject();

  public selectedCourseId: String
  public selectedZestCourse: any
  public selectedCountry: String;
  public isAlreadyMapped: boolean
  constructor(private fireDatabase: AngularFireDatabase,
    private datePipe: DatePipe, private oAuthService: OAuthService, private apiService: ApiService, private orderPipe: OrderPipe) {
    this.filterargs = {
      id: "",
      name: ''
    }
  }

  async  ngOnInit() {
    try {
      let countries = await this.apiService.get("/api/v1/countries")
      this.countries = countries.data
      console.log(this.countries);

    } catch (error) {
      console.log(error);

    }
  }

  public async onCountryChange(event) {
    console.log(event)
    this.imageLoader = true
    this.selectedCountry = event
    try {
      let courses = await this.apiService.get("/api/v1/facilities?country=" + event)
      this.courses = courses.data
      for (let l = 0; l < this.courses.length; l++) {
        this.courses[l].created = new Date(this.courses[l].created).getTime() / 1000
        this.courses[l].isMapped = ""
        const data = await this.getCourse(this.courses[l].id)

        if (data.length > 0) {
          this.courses[l].isMapped = data[0].$value + "=>" + data[1].$value
        }

      }
      console.log(this.courses);
      this.imageLoader = false

    } catch (error) {
      console.log(error);

    }
  }
  unmapped(tee) {
    if (confirm("Are you sure you want to unmapped this course?")) {
      this.apiService.set("zest-course-mapping/" + tee.id, null)
      tee.isMapped=""
    }
  }
  async getCourse(uid): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.apiService.list("zest-course-mapping/" + uid).then(result => {
        result.key = uid;
        resolve(result);
      });

    });
    return promise;
  }
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }
  openModal(club) {
    console.log(club);
    this.selectedZestCourse = club
    this.club = null
    this.selectedCourseId = null;
    this.clubCourses = []
    this.parentSubject.next(null);

    $('#myModal').modal('show');


  }
  changeClub(club: any) {
    this.clubCourses = []

    if (club && club.bank) {
      this.club = club
      lodash.forEach(club.courses, (course, key) => {
        this.clubCourses.push(lodash.assign(course, { $key: key }));
      });

      this.isBankAttached = false
    } else {
      this.isBankAttached = true

    }

  }
  onCourseChange(event) {
    console.log(event);
    let y = this.clubCourses.findIndex(y => y.name == event)
    this.selectedCourseId = this.clubCourses[y].$key
    console.log(this.selectedCourseId);
    this.apiService.list("zest-course-mapping", {
      query: {
        orderByChild: "courseId",
        equalTo: this.selectedCourseId
      }

    }).then(result => {
      console.log(result)
      if (result.length > 0) {
        this.isAlreadyMapped = true
      } else {
        this.isAlreadyMapped = false

      }
    });

  }
  mappedClub() {
    if (!this.isBankAttached && !this.isAlreadyMapped) {
      let req = {
        cid: this.club.$key,
        courseId: this.selectedCourseId
      }
      this.apiService.set("zest-course-mapping/" + this.selectedZestCourse.id, req)
      this.onCountryChange(this.selectedCountry)
      $('#myModal').modal('hide');
      this.club = null
      this.selectedCourseId = null;
      this.selectedZestCourse = null

    }

  }
}

